import { useEffect, useMemo, useState } from "react";
import { io } from "socket.io-client";

export const useSocket = (serverPath) => {
  const socket = useMemo(
    () =>
      io(serverPath, {
        reconnectionDelayMax: 10000,
      }),
    [serverPath]
  );
  const [online, setonline] = useState(false);
  useEffect(() => {
    socket.on("disconnect", () => {
      setonline(false);
    });
    // eslint-disable-next-line
  }, []);
  useEffect(() => {
    socket.on("connect", () => {
      setonline(true);
    });
    // eslint-disable-next-line
  }, []);
  return { socket, online };
};
